/**Auth actions */
export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER"
export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const RESET_PASSWORD = "RESET_PASSWORD"
export const UPLOAD_IMAGE = "UPLOAD_IMAGE"
export const VIEW_ACCOUNT = "VIEW_ACCOUNT"
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT"


/**Dashboard Actions */
export const DASHBOARD = "DASHBOARD"
export const DASHBOARD_MONTHLY_SALES = "DASHBOARD_MONTHLY_SALES";

/**Product Actions */
export const CREATE_PRODUCT = "CREATE_PRODUCT"
export const EDIT_PRODUCT = "EDIT_PRODUCT"
export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const VIEW_PRODUCT = "VIEW_PRODUCT"
export const LIST_PRODUCT = "LIST_PRODUCT"
export const BULK_UPLOAD_PRODUCT = "BULK_UPLOAD_PRODUCT"

export const PRODUCT_DROPDOWN = "PRODUCT_DROPDOWN"
export const GENERATE_BILL = "GENERATE_BILL"
export const TRANSACTIONS_LIST = "TRANSACTIONS_LIST"
export const EXPORT_REPORT = "EXPORT_REPORT"
export const SUBSCRIPTIONS_LIST = "SUBSCRIPTIONS_LIST"
export const CUSTOMERS_DROPDOWN = "CUSTOMERS_DROPDOWN"

export const STRIPE_CHECKOUT = "STRIPE_CHECKOUT";
export const PLANS_LIST = "PLANS_LIST";
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS"

export const RAZORPAY_CREATE_ORDER = "RAZORPAY_CREATE_ORDER"
export const RAZORPAY_PAYMENT_SUCCESS = "RAZORPAY_PAYMENT_SUCCESS"